import { Transform } from 'class-transformer';
import { DateFilter } from '../../interfaces/filters/date.filter';
import { OrderParamPair } from '../../interfaces/filters/order-param-pair';
import { OrderFilter } from '../../interfaces/filters/order.filter';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { SearchFilter } from '../../interfaces/filters/search.filter';
import { UserToMembershipDto } from '../dto';
import { jsonStringToObject } from '../../types-transformers';
import { IsOptional } from 'class-validator';

export class UserToMembershipFilter
	implements PaginationFilter, SearchFilter, DateFilter, OrderFilter<UserToMembershipDto>
{
	public search?: string;

	public page?: number;
	public pageSize?: number;

	public periodFrom?: Date;
	public periodTo?: Date;

	@Transform(jsonStringToObject)
	@IsOptional()
	public orderedBy?: OrderParamPair<UserToMembershipDto>[];
}
